import React, { useState } from 'react'

import styled from 'styled-components'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

import LiveModal from 'live/components/ui/Modal'
import i18n from 'live/services/i18n'

type EntityTypes =
    | WellDto
    | InterventionsDto
    | SectionDto
    | RigTableDto
    | RunDto
    | CementedPlugDto
    | TubularTypeDto
    | TubularRestrictedPipeMovementsDto
    | TubularRestrictedConnectionDto
    | TubularRestrictedRopDto

interface DeleteEntityButtonProps {
    entity: EntityTypes
    entityName: string
    handleDelete: (entity: EntityTypes) => void
}

export const DeleteEntityButton = ({ entity, entityName, handleDelete }: DeleteEntityButtonProps) => {
    const [isDeleteModal, setIsDeleteModal] = useState(false)

    return (
        <DeleteEntityButtonContainer>
            <>
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip style={{ zIndex: 9999 }} id="delete-entity-tooltip">
                            {`${i18n('Delete this')} ${i18n(entityName)}`}
                        </Tooltip>
                    }
                >
                    <i
                        className="far fa-trash-alt"
                        onClick={() => {
                            setIsDeleteModal(true)
                        }}
                    />
                </OverlayTrigger>

                <LiveModalWrapper show={isDeleteModal}>
                    <LiveModal.Header>
                        <LiveModal.Title>
                            <i className="fas fa-exclamation-circle" />
                            <span>{i18n('Attention!')}</span>
                        </LiveModal.Title>
                        <i className="far fa-times close-btn" onClick={() => setIsDeleteModal(false)} />
                    </LiveModal.Header>

                    <LiveModal.Body>
                        <span>{i18n('Are you sure you want to delete?')}</span>
                        <strong>{i18n('This action cannot be undone.')}</strong>
                    </LiveModal.Body>
                    <LiveModal.Footer>
                        <ActionBtn
                            onClick={() => {
                                handleDelete(entity)
                                setIsDeleteModal(false)
                            }}
                            className="btn btn-primary"
                        >
                            {i18n('Delete')}
                        </ActionBtn>
                        <ActionBtn
                            onClick={() => {
                                setIsDeleteModal(false)
                            }}
                            className="btn btn-secondary"
                        >
                            {i18n('Cancel')}
                        </ActionBtn>
                    </LiveModal.Footer>
                </LiveModalWrapper>
            </>
        </DeleteEntityButtonContainer>
    )
}

const DeleteEntityButtonContainer = styled.div`
    display: flex;
    justify-content: right;
    padding-right: 8px;

    .fa-trash-alt {
        cursor: pointer;
        color: var(--red-500);

        &:hover {
            opacity: 0.8;
        }
    }
`

const LiveModalWrapper = styled(LiveModal)`
    display: flex !important;

    .modal-dialog {
        margin: auto;
        width: 400px;

        .modal-header {
            .modal-title {
                color: var(--red-500);

                .fa-exclamation-circle {
                    margin-right: 4px;
                }
            }

            .close-btn {
                position: absolute;
                top: 16px;
                right: 25px;
                z-index: 9999;

                cursor: pointer;
            }
        }
    }

    .modal-body {
        display: flex;
        flex-direction: column;
    }
`
const ActionBtn = styled.button`
    font-size: 15px;
    font-weight: 600;
    padding: 8px 24px;

    border: none;
    border-radius: 3px;

    &.btn.btn-primary {
        border: 1px solid var(--red-500);
        color: white;
        background-color: var(--red-500);

        &:hover {
            opacity: 0.8;
        }
    }

    &.btn.btn-secondary {
        border: 1px solid var(--gray-400);
        color: var(--gray-800);
        background-color: transparent;

        &:hover {
            opacity: 0.8;
        }
    }
    &:focus {
        outline: none;
    }
`
